/* global ajaxUrl wikiUrl */

const box = document.getElementById('box-wiki')
const boxPlaceholder = document.getElementById('topic-placeholder')

if (box) {
    getTopic()
}

function getTopic() {
    if (verifyCache()) {
        boxPlaceholder.style.display = 'none'
        return createTopicMarkup(
            JSON.parse(sessionStorage.getItem('encyklopedie-topic'))
        )
    }

    fetch(ajaxUrl + '?action=random_topic')
        .then(function (response) {
            return response.json()
        })
        .then(function (data) {
            if (!data.success) {
                setDummy()
                return
            }
            data.data.content = replaceAll(
                data.data.content,
                'href="/index.php',
                'target="_blank" href="' + wikiUrl + 'index.php'
            )
            sessionStorage.setItem('encyklopedie-topic-date', Date.now())
            sessionStorage.setItem(
                'encyklopedie-topic',
                JSON.stringify(data.data)
            )
            boxPlaceholder.style.display = 'none'
            return createTopicMarkup(data.data)
        })
        .catch(function (error) {
            console.error(error)
            setDummy()
        })
}

function createTopicMarkup(data) {
    box.querySelector('.wiki-content').innerHTML = data.content
    box.querySelector('.topic-more-link').style.display = 'block'
    box.querySelector('.topic-more-link a').href = data.url

    if (data.images) {
        box.querySelector('.box-links').classList.add('with-img')
        box.querySelector('.box-title').classList.add('with-img')
    }
}

function verifyCache() {
    const cachedDate = sessionStorage['encyklopedie-topic-date']
    const interval = 60000 // 1 minute

    if (!cachedDate) {
        return false
    }

    return cachedDate > Date.now() - interval
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace)
}

function setDummy() {
    boxPlaceholder.style.display = 'block'
    boxPlaceholder.style.color = 'initial'
    boxPlaceholder.style.textShadow = 'none'

    boxPlaceholder.setAttribute('aria-hidden', false)
    boxPlaceholder.removeAttribute('role')
}
